module.exports = __webpack_public_path__ + "img/seal-default.6e14cf48.png";